import { NewExclusionListWebComponent } from './component/NewExclusionListWebComponent';
import { WEB_COMPONENT_NEW_EXCLUSION_LIST } from '../../webcomponents.constants';

/**
 * The component for adding a new list or new exclusions
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { NewExclusionListWebComponent };

window.customElements.define(WEB_COMPONENT_NEW_EXCLUSION_LIST, NewExclusionListWebComponent);
